export const sitemapUrl = 'http://localhost:3000';

export const sitemapRoutes = [
	{
		path: '/',
		disable: false,
		title: '넷플레이스 - 로그인',
		desc: '넷플레이스 메타 로그인 페이지입니다.',
		keywords: ['login', 'netplace', '넷플레이스'],
	},
	{
		path: '/login',
		disable: false,
		title: '넷플레이스 - 로그인',
		desc: '넷플레이스 메타 로그인 페이지입니다.',
		keywords: ['login', 'netplace', '넷플레이스'],
	},
	{
		path: '/register',
		disable: false,
		title: '넷플레이스 - 회원가입',
		desc: '넷플레이스 메타 회원가입 페이지입니다.',
		keywords: ['register', 'netplace', '넷플레이스'],
	},
	{
		path: '/find/id',
		disable: false,
		title: '넷플레이스 - 아이디 찾기',
		desc: '넷플레이스 메타 아이디 찾기 페이지입니다.',
		keywords: ['find', 'id', 'email', 'netplace', '넷플레이스'],
	},
	{
		path: '/find/password',
		disable: false,
		title: '넷플레이스 - 비밀번호 찾기',
		desc: '넷플레이스 메타 비밀번호 찾기 페이지입니다.',
		keywords: ['find', 'password', 'netplace', '넷플레이스'],
	},

	{
		path: '/main',
		disable: true,
		title: '넷플레이스',
		desc: '넷플레이스 메타 메인 홈 페이지입니다.',
		keywords: ['netplace', '넷플레이스'],
	},

	{
		path: '/guide',
		disable: true,
		title: '넷플레이스 - 이용안내',
		desc: '넷플레이스 메타 이용안내 페이지입니다.',
		keywords: ['guide', 'netplace', '넷플레이스'],
	},
	{
		path: '/guide/post',
		disable: true,
		title: '넷플레이스 - 이용안내',
		desc: '넷플레이스 메타 이용안내 페이지입니다.',
		keywords: ['guide', 'netplace', '넷플레이스'],
	},

	{
		path: '/notice',
		disable: true,
		title: '넷플레이스 - 공지사항',
		desc: '넷플레이스 메타 공지사항 페이지입니다.',
		keywords: ['notice', 'netplace', '넷플레이스'],
	},
	{
		path: '/notice/post',
		disable: true,
		title: '넷플레이스 - 공지사항',
		desc: '넷플레이스 메타 공지사항 페이지입니다.',
		keywords: ['notice', 'netplace', '넷플레이스'],
	},

	{
		path: '/mypage',
		disable: true,
		title: '넷플레이스 - 마이페이지',
		desc: '넷플레이스 메타 마이 페이지입니다.',
		keywords: ['mypage', 'netplace', '넷플레이스'],
	},

	{
		path: '/review',
		disable: true,
		title: '넷플레이스 - 리뷰',
		desc: '넷플레이스 메타 리뷰 페이지입니다.',
		keywords: ['review', 'netplace', '넷플레이스'],
	},
	{
		path: '/review/post',
		disable: true,
		title: '넷플레이스 - 리뷰',
		desc: '넷플레이스 메타 리뷰 페이지입니다.',
		keywords: ['review', 'netplace', '넷플레이스'],
	},
	{
		path: '/review/apply',
		disable: true,
		title: '넷플레이스 - 리뷰 신청',
		desc: '넷플레이스 메타 리뷰 신청 페이지입니다.',
		keywords: ['review', 'netplace', '넷플레이스'],
	},

	{
		path: '/visit-experience',
		disable: true,
		title: '넷플레이스 - 체험단',
		desc: '넷플레이스 메타 체험단 페이지입니다.',
		keywords: ['visit-experience', 'netplace', '넷플레이스'],
	},
	{
		path: '/viewtab-instagram',
		disable: true,
		title: '넷플레이스 - 뷰탭&인스타',
		desc: '넷플레이스 메타 뷰탭&인스타 페이지입니다.',
		keywords: ['viewtab-instagram', 'netplace', '넷플레이스'],
	},
	{
		path: '/website-outsourcing',
		disable: true,
		title: '넷플레이스 - 홈페이지 제작',
		desc: '넷플레이스 메타 홈페이지 제작 페이지입니다.',
		keywords: ['website-outsourcing', 'netplace', '넷플레이스'],
	},
];
